import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import Icon from '../Icon';
import StatusPill from '../StatusPill';
import LinkCopyButton from '../LinkCopyButton';

export default class StaffCurriculumResourcesList extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    defaultSort: null,
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>
          <div className="u-font-semibold u-truncate">
            <a href={item.staff_url}>
              { item.title }
            </a>
          </div>
        </td>
        <td>
          <a href={item.curator.staff_url}>
            <div className="u-flex u-items-center">
              <Avatar
                className="StaffTable-avatar u-mr-2"
                src={item.curator.avatar_url}
                type="user"
                showInitials
                name={item.curator.name}
              />
              <div className="u-font-semibold u-truncate">
                {item.curator.name}
              </div>
            </div>
          </a>
        </td>
        <td>
          {item.courses.map((course) => (
            <a href={course.url} className="u-truncate u-block u-font-semibold">
              {course.title}
            </a>
          ))}
        </td>
        <td>{ item.view_count }</td>
        <td>{ item.comments_count }</td>
        <td>{ item.votes_count }</td>
        <td>
          <StatusPill status={item.published_state} />
        </td>
        <td className="actions">
          <a href={item.edit_staff_url} className="Button u-mr-2">
            <Icon name="edit" className="u-mr-0" />
          </a>
          <div className="u-inline-block">
            <LinkCopyButton url={item.public_url} name={item.title} />
          </div>
        </td>
      </tr>
    );
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow}
      />
    );
  }
}
